import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ServiceHistory } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getServiceHistory(axios: AxiosInstance, id: number): Promise<ServiceHistory> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v2/service-history-request/` + id);
  return data.data;
}

export default function useServiceHistoryQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getServiceHistory(axios, id),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

export function getKey(id: number) {
  return ['ServiceHistory', id] as const satisfies QueryKey;
}
useServiceHistoryQuery.getKey = getKey;
